/**
 * Created by ChrisMuto on 7/18/17.
 */
export const DID_TOGGLE_SELECTED_PAGE =
    "Results: toggled the selected page for results";

export const DID_NAVIGATE_TO_COMPARE_PAGES =
    "Results: navigated to compare pages";
export const DID_CHANGE_BASELINE_PAGE =
    "Results: changed the baseline page on compare pages";

export const DID_NAVIGATE_TO_HEATMAP = "Results: navigated to heatmap";

export const DID_CHANGE_HEATMAP_SEGMENT = "Results: changed heatmap segment";
export const DID_CHANGE_HEATMAP_CONTENT = "Results: changed heatmap content";

export const DID_HIDE_HEATMAP = "Results: hid the heatmap overlay";
export const DID_SHOW_HEATMAP = "Results: showed the heatmap overlay";
export const DID_HIDE_ANNOTATION_OVERLAY =
    "Results: hid the annotation overlay";
export const DID_SHOW_ANNOTATION_OVERLAY =
    "Results: showed the annotation overlay";

export const DID_NAVIGATE_TO_NEXT_STEPS = "Results: navigated to next steps";
export const DID_SELECT_NEXT_STEP = "Results: selected next step to take";



// WEBPACK FOOTER //
// ./src/modules/tracker/event-names/results-events.js